export default __webpack_public_path__ + "static/media/office-training-tab6bg.42030c51.png";